import { FC, ReactNode } from 'react';

import { Bleed, Stack, Text } from '@eneco/sparky';

import InfoComponent from './InfoComponent';
import { LoadingText } from './Loading/LoadingText';
import { maxWidthStackClass } from '../styles/components.css';

type ReadFormFieldProps = {
  label: string | ReactNode;
  value: ReactNode | undefined | null;
  infoText?: string;
  size?: 'BodyS' | 'BodyM';
  isLoading?: boolean;
  isLoadingLabel?: boolean;
};
const ReadFormField: FC<ReadFormFieldProps> = ({
  label,
  value,
  infoText,
  size = 'BodyM',
  isLoading,
  isLoadingLabel,
}) => {
  const loadingTextHeight = size === 'BodyM' ? 24 : 16;
  return (
    <Stack className={maxWidthStackClass} gap="1">
      <Stack direction="row" alignY="center">
        {isLoadingLabel ? (
          <LoadingText height={loadingTextHeight} width={170} />
        ) : (
          <Text size={size} weight="bold">
            {label}
          </Text>
        )}

        {infoText && typeof label === 'string' && (
          <Bleed vertical={4}>
            <InfoComponent variant="icon" triggerText={label}>
              {infoText}
            </InfoComponent>
          </Bleed>
        )}
      </Stack>
      {isLoading ? (
        <LoadingText height={loadingTextHeight} />
      ) : (
        <Text size={size}>{value || value === 0 ? value : '-'}</Text>
      )}
    </Stack>
  );
};

export default ReadFormField;
